import type React from "react";
import "../App.scss";
import "./SubscriptionInfo.scss";
import { useAuthenticatedAuthContext } from "../auth/Auth.component";
import Faq from "./Faq";
import SubscriptionInfoSummary from "./SubscriptionInfoSummary";

const SubscriptionInfoPage: React.FC = () => {
	const context = useAuthenticatedAuthContext();

	const hasTravelSubscription =
		context.selectedCompany.availableSubscriptions.some(
			(x) => x.type === "TRAVEL_SUBSCRIPTION",
		);

	const isHousingCooperative =
		context.selectedCompany.subTypeId === "HOUSING_COOPERATIVE_AGREEMENT";

	return (
		<div
			data-test-id="electric-bike-info-page"
			className="components-wrapper-subscription-info"
		>
			<SubscriptionInfoSummary
				hasTravelSubscription={hasTravelSubscription}
				title={
					<h1>
						{isHousingCooperative
							? "Reiseabonnement for borettslag"
							: "Reiseabonnement for bedrifter"}
					</h1>
				}
				isHousingCooperative={isHousingCooperative}
			/>
			<h2>Vanlige spørsmål</h2>
			<Faq />
		</div>
	);
};

export default SubscriptionInfoPage;
